import * as React from "react";
import { useHistory } from "react-router-dom";
import SelectDataSource from "../smart-match/SelectDataSource";
import MapColumns from "../smart-match/MapColumns";
import { useSmartMatch } from "../../hooks/useSmartMatch";

const SmartMatchRoute: React.FC = () => {
  const history = useHistory();
  const smartMatch = useSmartMatch();

  const handleNext = () => {
    smartMatch.nextStep();
  };

  const handleBack = () => {
    smartMatch.previousStep();
  };

  const handleComplete = () => {
    console.log("Smart Match completed successfully! Results written to Excel sheet.");
  };

  const renderCurrentStep = () => {
    switch (smartMatch.state.currentStep) {
      case 1:
        return <SelectDataSource onNext={handleNext} smartMatch={smartMatch} />;
      case 2:
        return <MapColumns onNext={handleComplete} onBack={handleBack} smartMatch={smartMatch} />;
      default:
        return <SelectDataSource onNext={handleNext} smartMatch={smartMatch} />;
    }
  };

  return (
    <div>
      {renderCurrentStep()}
    </div>
  );
};

export default SmartMatchRoute;
